import React, { FC, useEffect, useLayoutEffect } from 'react'
import {
  addPendingRedirect,
  ENavPages,
  navConfig,
  useAppDispatch
} from '../internal';

interface IForwardProps {
  match: any,
  toPage: ENavPages,
  replaceHistory?: boolean,
}
const ForwardTo: FC<IForwardProps> = ({ toPage, replaceHistory, match }) => {

  const dispatch = useAppDispatch();
  
  useLayoutEffect(() => {
    const toPath = navConfig.get(toPage)!.linkTo([]);
    const pathParams = [];
    if (toPath.includes('/:')) {
      const guidRegexG = /(?:(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12})/g;
      pathParams.push(window.location.href.match(guidRegexG)); 
    }
    dispatch(addPendingRedirect({
      pathname: navConfig.get(toPage)!.linkTo(pathParams),
      useHistoryReplace: replaceHistory ?? true }));
  }, []);
  
  return null;
}

export default ForwardTo;